// for add employee
export const RESET_ADD_EMPLOYEE_Education = "reset_add_employee_education";
export const ADD_EMPLOYEE_Education = "add_employee_education";
export const ADD_EMPLOYEE_Education_SUCCESS = "add_employee_education_success";
export const ADD_EMPLOYEE_Education_FAILURE = "add_employee_education_failure";
